import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Card = styled.div`
  box-shadow: 0 0 4px 0 #CFD3D8;
  background-color: #FEFEFE;
  border-radius: 8px;
  padding: 64px 40px;
`
export const ContainerCookieBanner = styled.div`
  width: 100vw;
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 0;
  z-index: 5;
`
export const DivCookiebanner = styled.div`
  background-color: #FFFFFF;
  width: 820px;
  height: ${(props) => (props.visivel ? '173px' : '0')};
  box-shadow: 0px 2px 16px rgba(40, 67, 91, 0.3);
  border-radius: 8px 8px 0 0;
  visibility: ${(props) => (props.visivel ? 'visible' : 'hidden')};
  transition: height 0.3s;
  padding: 20px 16px;
  box-sizing: border-box;
`

export const TituloCookieBanners = styled.p`
  margin: 0px 0 16px 0px;
  color: #003563;
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
`
export const ContainerConteudoDivBanner = styled.div`
  display: flex;
  justify-content: space-between;

`
export const TextoCookieBanner = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 19px;
`
const SpanBotoesCookiesBanner = styled.span`
  flex-basis: 20%;
`

export const Botao = styled.input`
  margin-left: 16px;
`

export const NavBar = styled.header`
  height: 72px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  background-color: #003563;
  color: white;
  padding: 8px 32px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  z-index: 1;

  @media (max-width: 799px) { 
    height: 56px;
    font-size: 14px;
    padding: 8px 16px;
  }
`

export const ImagemHeader = styled.img`
  width: 56px;
  height: 56px;
  margin-right: 16px;

  @media (max-width: 799px) { 
    width: 32px;
    height: 32px;
  }
`

export const Body = styled.div`
  margin-top: 80px;

  @media (max-width: 799px) { 
    margin-top: 72px;
  }
`

export const TituloHeader = styled.p`
  display: inline;
  font-size: 32px;
  font-weight: bold;

  @media (max-width: 799px) { 
    font-size: 20px;
  }
`

export const SpanTitulo = styled.span`
  display: flex;
  align-items: center;
`

export const SpanMenu = styled.span`
  display: flex;
  justify-content: space-between;

  &:hover{
    cursor: pointer;
  }
`

export const MenuItens = styled.span`
  margin: 0 16px;

  &:hover{
    color: #C9D5DF;
  }

  @media (max-width: 799px) { 
    margin: 0 8px;
  }
`

export const LinkTitulo = styled(Link)`
  text-decoration: none;
  color: white;
`

export const BotaoEstilizado = styled.button`
  font-size:  ${(props) => (props.empresa ? '24px' : '14px')};
  color: ${(props) => (props.inverse ? '#003563' : '#FEFEFE')};
  background-color: ${(props) => (props.inverse ? '#FEFEFE' : props.empresa ? '#E3662A' : props.cor ? props.cor : '#003563')};
  text-transform: capitalize;
  width: ${(props) => (props.largura ? props.largura : '96px')};
  height: ${(props) => (props.altura ? props.altura : 'unset')};
  margin: 0;
  border-radius: ${(props) => (props.empresa ? '0 7px 7px 0' : '8px')};
  border:  ${(props) => (props.inverse ? '1px solid  #003563' : 'none')};
  outline: none;
  cursor: pointer;

  &:hover{
    background-color: ${(props) => (props.inverse ? '#C8EEFB' : props.empresa ? '#E1865B' : props.corHover ? props.corHover : '#348DCF')};
  }

  &:active{
    background-color: ${(props) => (props.inverse ? '#FEFEFE' : props.empresa ? '#CF5D26' : props.cor ? props.cor : '#004796')};
    @media (max-width: 799px) {
      background-color: ${(props) => (props.inverse ? '#FEFEFE' : props.empresa ? '#CF5D26' : '#004796')};
    }
  }

  &:disabled {
    background-color: ${(props) => (props.personalizado ? '#FEFEFE' : '#CFD3D8')};
    color:  ${(props) => (props.personalizado ? '#BDC1C7' : '#636669')};
    border: ${(props) => (props.personalizado ? '1px solid #BDC1C7' : 'none')};
  }

  @media (max-width: 799px) {
    width: ${(props) => (props.largura ? props.largura : '48px')};
    height: ${(props) => (props.altura ? props.altura : 'unset')};
  }
`

export const BotaoComCifrao = styled(BotaoEstilizado)`
  box-shadow: 0 0 10px 0 rgba(69,103,140,0.63);
`

export const DivBotaoCifrao = styled.div`
  display: flex;
  justify-content: center;
`

export const DivCifrao = styled.div`
  position: absolute;
  right: 16px;
`

export const DivCheck = styled.div`
  position: relative;
  right: ${(props) => (props.senha ? '-15%' : '-35%')};

  @media (max-width: 799px) {
    right: -16px;
  }  
`

export const DivProximo = styled.div`
  position: relative;
  right: -4px;
`

export const DivAnterior = styled.div`
  position: relative;
  left: -4px;
`

export const DivBotaoPersonalizado = styled.div`
  display: flex;
  padding: 0px;
  height: 100%;
  justify-content: center;
  align-items: center;

  p {
    margin-top: 2px;
    margin-bottom: 2px;
  }

  img {
    position: absolute;
    left: 406px;
  }

  @media (max-width: 799px) {
    img {
      left: 24px;
    }
  }
`

export const DivBotaoIconeDireita = styled.div`
  padding: 0px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    margin-top: 2px;
    margin-bottom: 2px;
  }

  @media (max-width: 799px) {
    img {
      left: 24px;
    }
  }
`

export const DivContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;  
  align-items: center;
`

export const PAguarde = styled.p`
  color: #003563;
  margin: 4px 0 0 8px;
`

export default SpanBotoesCookiesBanner
